/* Calendar-style variant picker — modal/popout edition.
   Reuses the theme's existing variant-change pipeline:
   day click → toggle hidden radio → dispatch native 'change'
   → inline jQuery in product-form.liquid triggers the form change
   → theme.js updates variant id, price, ATC state. */
(function () {
  'use strict';

  var MONTHS = {
    jan: 0, january: 0,
    feb: 1, february: 1,
    mar: 2, march: 2,
    apr: 3, april: 3,
    may: 4,
    jun: 5, june: 5,
    jul: 6, july: 6,
    aug: 7, august: 7,
    sep: 8, sept: 8, september: 8,
    oct: 9, october: 9,
    nov: 10, november: 10,
    dec: 11, december: 11
  };

  var WEEK_HEADERS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var MONTH_FULL = ['January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'];
  var WEEKDAYS_FULL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var DESKTOP_MIN_WIDTH = 1024;

  function parseDate(raw, defaultYear) {
    if (!raw) return null;
    var s = String(raw).trim();

    var iso = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (iso) {
      var y = parseInt(iso[1], 10);
      var m = parseInt(iso[2], 10) - 1;
      var d = parseInt(iso[3], 10);
      if (m >= 0 && m <= 11 && d >= 1 && d <= 31) return new Date(y, m, d);
      return null;
    }

    var named = s.match(/^([A-Za-z]+)\s+(\d{1,2})(?:[,\s]+(\d{4}))?$/);
    if (named) {
      var monthKey = named[1].toLowerCase();
      var month = MONTHS[monthKey];
      if (month === undefined) return null;
      var day = parseInt(named[2], 10);
      if (day < 1 || day > 31) return null;
      var year = named[3] ? parseInt(named[3], 10) : defaultYear;
      return new Date(year, month, day);
    }

    return null;
  }

  function startOfDay(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function fmtTrigger(d) {
    return WEEKDAYS_FULL[d.getDay()].slice(0, 3) + ', ' + MONTH_FULL[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }

  function fmtMonthLabel(year, month) {
    return MONTH_FULL[month] + ' ' + year;
  }

  function ymKey(year, month) {
    return year + '-' + month;
  }

  function dateIso(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  /* Monday-indexed weekday: Mon=0..Sun=6 */
  function mondayIdx(d) {
    var js = d.getDay(); // Sun=0..Sat=6
    return (js + 6) % 7;
  }

  function init(picker) {
    if (picker.dataset.calendarInitialized === '1') return;
    picker.dataset.calendarInitialized = '1';

    var defaultYear = parseInt(picker.dataset.defaultYear, 10) || new Date().getFullYear();
    var todayStr = picker.dataset.today;
    var today = todayStr ? startOfDay(new Date(todayStr + 'T00:00:00')) : startOfDay(new Date());

    var trigger = picker.querySelector('[data-calendar-trigger]');
    var triggerLabel = picker.querySelector('[data-calendar-trigger-label]');
    var modal = picker.querySelector('[data-calendar-modal]');
    var backdrop = picker.querySelector('[data-calendar-backdrop]');
    var sheet = picker.querySelector('[data-calendar-sheet]');
    var body = picker.querySelector('[data-calendar-body]');
    var closeBtn = picker.querySelector('[data-calendar-close]');
    var radios = Array.prototype.slice.call(picker.querySelectorAll('[data-calendar-radio]'));

    if (!trigger || !modal || !body || radios.length === 0) return;

    /* Build the value→{date,radio,available} map. */
    var entries = [];
    var unparsedValues = [];
    radios.forEach(function (radio) {
      var raw = radio.dataset.value;
      var date = parseDate(raw, defaultYear);
      if (!date) {
        try { console.warn('[calendar-picker] Could not parse variant value:', raw); } catch (_e) {}
        unparsedValues.push({ value: raw, radio: radio });
        return;
      }
      entries.push({
        date: date,
        iso: dateIso(date),
        radio: radio,
        rawValue: raw,
        available: !radio.disabled && date >= today
      });
    });

    if (entries.length === 0) {
      // Nothing parseable: render unparsed values as plain buttons inside the body
      // so the user can still select. Keep trigger label as "Select date".
      sheet.style.maxWidth = '320px';
      body.innerHTML = '<div class="calendar-picker__unparsed-list" role="list"></div>';
      var list = body.firstElementChild;
      unparsedValues.forEach(function (u) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'calendar-picker__unparsed-tile' + (u.radio.disabled ? ' is-soldout' : '');
        b.textContent = u.value;
        b.dataset.unparsedRadio = u.radio.id;
        b.setAttribute('role', 'listitem');
        if (u.radio.disabled) { b.setAttribute('aria-disabled', 'true'); b.disabled = true; }
        list.appendChild(b);
      });
      list.addEventListener('click', function (e) {
        var t = e.target.closest('button[data-unparsed-radio]');
        if (!t || t.disabled) return;
        var r = document.getElementById(t.dataset.unparsedRadio);
        if (!r) return;
        selectRadio(r);
        closeModal();
      });
    } else {
      /* Sort entries by date and build month list (every consecutive month from first to last). */
      entries.sort(function (a, b) { return a.date - b.date; });
      var firstDate = entries[0].date;
      var lastDate = entries[entries.length - 1].date;

      var months = [];
      var cur = new Date(firstDate.getFullYear(), firstDate.getMonth(), 1);
      var end = new Date(lastDate.getFullYear(), lastDate.getMonth(), 1);
      while (cur <= end) {
        months.push({ year: cur.getFullYear(), month: cur.getMonth() });
        cur.setMonth(cur.getMonth() + 1);
      }

      // Index entries by ISO date for fast lookup.
      var entryByIso = {};
      entries.forEach(function (e) { entryByIso[e.iso] = e; });

      renderModalBody(body, months, entryByIso, today);

      // Append unparsed fallback list below the calendar if any
      if (unparsedValues.length > 0) {
        var unparsedSection = document.createElement('div');
        unparsedSection.className = 'calendar-picker__unparsed-section';
        var heading = document.createElement('p');
        heading.className = 'calendar-picker__unparsed-heading';
        heading.textContent = 'Other dates';
        unparsedSection.appendChild(heading);
        var ulist = document.createElement('div');
        ulist.className = 'calendar-picker__unparsed-list';
        unparsedValues.forEach(function (u) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'calendar-picker__unparsed-tile' + (u.radio.disabled ? ' is-soldout' : '');
          b.textContent = u.value;
          b.dataset.unparsedRadio = u.radio.id;
          if (u.radio.disabled) { b.setAttribute('aria-disabled', 'true'); b.disabled = true; }
          ulist.appendChild(b);
        });
        unparsedSection.appendChild(ulist);
        body.appendChild(unparsedSection);
        ulist.addEventListener('click', function (e) {
          var t = e.target.closest('button[data-unparsed-radio]');
          if (!t || t.disabled) return;
          var r = document.getElementById(t.dataset.unparsedRadio);
          if (!r) return;
          selectRadio(r);
          closeModal();
        });
      }

      /* Update layout: 2 months side-by-side on desktop, 1 with prev/next on mobile. */
      applyLayout();
      var resizeRaf;
      window.addEventListener('resize', function () {
        if (resizeRaf) return;
        resizeRaf = requestAnimationFrame(function () {
          resizeRaf = null;
          applyLayout();
        });
      });
    }

    function applyLayout() {
      var isDesktop = window.matchMedia('(min-width: ' + DESKTOP_MIN_WIDTH + 'px)').matches;
      var grid = body.querySelector('.calendar-picker__grid');
      if (!grid) return;
      grid.dataset.layout = isDesktop ? 'desktop' : 'mobile';

      var monthEls = Array.prototype.slice.call(grid.querySelectorAll('.calendar-picker__month'));
      if (isDesktop) {
        monthEls.forEach(function (m) { m.hidden = false; });
        var nav = grid.querySelector('.calendar-picker__month-nav');
        if (nav) nav.hidden = true;
      } else {
        // Mobile: render months in a vertical scroll (all visible, scroll through them).
        // GYG mobile pattern is to stack months. We keep them all visible — the modal body scrolls.
        monthEls.forEach(function (m) { m.hidden = false; });
        var nav2 = grid.querySelector('.calendar-picker__month-nav');
        if (nav2) nav2.hidden = true;
      }
    }

    /* --- Modal open / close --- */
    var lastFocused = null;

    function openModal() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('calendar-picker-modal-open');
      // Focus the close button so screen readers announce the dialog.
      setTimeout(function () {
        if (closeBtn) closeBtn.focus();
      }, 0);
      document.addEventListener('keydown', onKeyDown);

      // Scroll selected day into view on mobile, top of grid on desktop.
      requestAnimationFrame(function () {
        var sel = body.querySelector('.calendar-picker__day.is-selected') ||
                  body.querySelector('.calendar-picker__day.is-available');
        if (sel) sel.scrollIntoView({ block: 'center', behavior: 'auto' });
      });
    }

    function closeModal() {
      modal.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('calendar-picker-modal-open');
      document.removeEventListener('keydown', onKeyDown);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      } else {
        trigger.focus();
      }
    }

    function onKeyDown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeModal();
        return;
      }
      // Simple focus trap: keep focus inside the sheet
      if (e.key === 'Tab') {
        var focusables = sheet.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])');
        if (focusables.length === 0) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    trigger.addEventListener('click', function () {
      if (modal.hidden) openModal(); else closeModal();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);

    /* --- Day click → select radio --- */
    body.addEventListener('click', function (e) {
      var dayBtn = e.target.closest('button.calendar-picker__day');
      if (!dayBtn || dayBtn.disabled) return;
      var radioId = dayBtn.dataset.radioId;
      if (!radioId) return;
      var radio = document.getElementById(radioId);
      if (!radio) return;
      selectRadio(radio);
      // Update selected state in grid
      Array.prototype.forEach.call(body.querySelectorAll('.calendar-picker__day.is-selected'), function (el) {
        el.classList.remove('is-selected');
        el.setAttribute('aria-pressed', 'false');
      });
      dayBtn.classList.add('is-selected');
      dayBtn.setAttribute('aria-pressed', 'true');
      // Update trigger label
      var raw = radio.dataset.value;
      var d = parseDate(raw, defaultYear);
      if (triggerLabel) triggerLabel.textContent = d ? fmtTrigger(d) : raw;
      closeModal();
    });

    function selectRadio(radio) {
      if (!radio || radio.disabled) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      radio.dispatchEvent(new Event('input', { bubbles: true }));
    }

    /* --- Set initial trigger label --- */
    var checkedRadio = picker.querySelector('[data-calendar-radio]:checked');
    if (checkedRadio) {
      var d = parseDate(checkedRadio.dataset.value, defaultYear);
      if (triggerLabel) triggerLabel.textContent = d ? fmtTrigger(d) : checkedRadio.dataset.value;
    } else if (entries.length > 0) {
      var firstAvail = entries.find(function (e) { return e.available; }) || entries[0];
      if (firstAvail && triggerLabel) triggerLabel.textContent = fmtTrigger(firstAvail.date);
    } else if (unparsedValues.length > 0 && triggerLabel) {
      triggerLabel.textContent = unparsedValues[0].value;
    }
  }

  function renderModalBody(body, months, entryByIso, today) {
    var grid = document.createElement('div');
    grid.className = 'calendar-picker__grid';
    grid.dataset.layout = 'desktop';

    months.forEach(function (m) {
      grid.appendChild(buildMonthEl(m.year, m.month, entryByIso, today));
    });

    body.appendChild(grid);
  }

  function buildMonthEl(year, month, entryByIso, today) {
    var wrap = document.createElement('div');
    wrap.className = 'calendar-picker__month';
    wrap.dataset.ym = ymKey(year, month);

    var title = document.createElement('div');
    title.className = 'calendar-picker__month-title';
    title.textContent = fmtMonthLabel(year, month);
    wrap.appendChild(title);

    var head = document.createElement('div');
    head.className = 'calendar-picker__weekdays';
    head.setAttribute('aria-hidden', 'true');
    WEEK_HEADERS.forEach(function (w) {
      var c = document.createElement('span');
      c.className = 'calendar-picker__weekday';
      c.textContent = w;
      head.appendChild(c);
    });
    wrap.appendChild(head);

    var daysGrid = document.createElement('div');
    daysGrid.className = 'calendar-picker__days';

    var first = new Date(year, month, 1);
    var pad = mondayIdx(first); // 0..6
    var daysInMonth = new Date(year, month + 1, 0).getDate();

    for (var i = 0; i < pad; i++) {
      var empty = document.createElement('span');
      empty.className = 'calendar-picker__day-empty';
      empty.setAttribute('aria-hidden', 'true');
      daysGrid.appendChild(empty);
    }

    for (var d = 1; d <= daysInMonth; d++) {
      var dateObj = new Date(year, month, d);
      var iso = year + '-' + String(month + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
      var entry = entryByIso[iso];
      var isPast = dateObj < today;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'calendar-picker__day';
      btn.dataset.date = iso;

      var fullLabelDate = WEEKDAYS_FULL[dateObj.getDay()] + ' ' + MONTH_FULL[month] + ' ' + d + ', ' + year;

      if (!entry) {
        // No variant for this date — render disabled, strikethrough, no radio link.
        btn.disabled = true;
        btn.classList.add('is-unavailable');
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('aria-label', fullLabelDate + ', unavailable');
      } else if (isPast) {
        btn.disabled = true;
        btn.classList.add('is-past');
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('aria-label', fullLabelDate + ', in the past');
      } else if (entry.radio.disabled) {
        btn.disabled = true;
        btn.classList.add('is-soldout');
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('aria-label', fullLabelDate + ', sold out');
      } else {
        btn.classList.add('is-available');
        btn.dataset.radioId = entry.radio.id;
        btn.setAttribute('aria-label', fullLabelDate + ', available');
        if (entry.radio.checked) {
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
        } else {
          btn.setAttribute('aria-pressed', 'false');
        }
      }

      btn.textContent = String(d);
      daysGrid.appendChild(btn);
    }

    wrap.appendChild(daysGrid);
    return wrap;
  }

  function initAll() {
    var pickers = document.querySelectorAll('[data-calendar-picker]');
    Array.prototype.forEach.call(pickers, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
